<!--suppress ALL -->
<script lang="ts">
import {pengajianPutras} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class PengajianPutraSelect extends Vue {

    @Prop({default: pengajianPutras[0].value, type: String})
    private pengajian: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.pengajian').toString(),
      type: String
    })
    public label: string;

    @Prop({type: String, default: ""})
    public message: string;

    @Prop({type: String, default: ""})
    public type: string;

    public onSelectPengajian(param: string) {
      this.$emit('update:pengajian', param || pengajianPutras[0].value);
      this.$emit('pengajian-selected', param);
    }

    public render(createElement: Function) {
      const {$t, pengajian, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: pengajian, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectPengajian}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(pengajianPutras).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
